import { Html5Qrcode } from 'html5-qrcode'
import memoizee from 'memoizee'
import { I18N_localize } from '../../zap/I18N/I18N.localize'
import { Plat_isCordova, Plat_vibrate } from '../../zap/Plat/Plat.device'
import { UI_dialogClose, UI_dialogOk, UI_dialogOpen } from '../../zap/UI/UI.Dialog'
import { WebBarcodeWrapper } from '../../../app-core/lib/ui/WebBarcodeModal'
import { waitForDomElem } from '../../../shared/lib/helpers'
import * as LaunchDarkly from '../../zap/Util/Util.launchdarkly'

const ZOOM_LEVELS = [0.5, 1, 3, 8]
let currentZoomIndex = 0

const getCameras = memoizee(Html5Qrcode.getCameras)

export function barcodeScan() {
    return new Promise<string>(async (resolve, reject) => {
        try {
            if (Plat_isCordova()) {
                window.MLKitBarcodeScanner.scanBarcode(
                    0,
                    (barcode: string) => {
                        Plat_vibrate(100)
                        return resolve(barcode)
                    },
                    reject
                )
            } else {
                const cameras = await getCameras()

                if (!cameras?.length) {
                    UI_dialogOk(I18N_localize('barcode.notSupported'), I18N_localize('barcode.noCameraScan'))
                    return reject()
                }

                UI_dialogOpen(
                    {
                        className: 'barcode-modal',
                        onRequestClose: () => {
                            html5QrCode.stop()
                            UI_dialogClose()
                            camContainer.removeEventListener('touchstart', onTouchStart)
                            return reject()
                        },
                    },
                    WebBarcodeWrapper()
                )

                const html5QrCode = new Html5Qrcode('web-barcode-reader')
                const config = { fps: 25, qrbox: { width: 250, height: 250 } }

                const camContainer = (await waitForDomElem('#web-barcode-reader')) as HTMLElement
                const onTouchStart = () => {
                    currentZoomIndex = (currentZoomIndex + 1) % ZOOM_LEVELS.length
                    setCamZoom(ZOOM_LEVELS[currentZoomIndex])
                }

                if (LaunchDarkly.getFlagValue('barcode-zoom-on-touch', false)) {
                    camContainer.addEventListener('touchstart', onTouchStart)
                }

                html5QrCode.start({ facingMode: 'environment' }, config as any, onScanSuccess, null).then(() => {
                    html5QrCode.applyVideoConstraints({
                        focusMode: 'continuous',
                        facingMode: 'environment',
                        advanced: [
                            {
                                zoom: ZOOM_LEVELS[currentZoomIndex],
                            },
                        ],
                    } as any)
                })

                function setCamZoom(zoomLevel: number) {
                    html5QrCode.applyVideoConstraints({
                        advanced: [
                            {
                                zoom: zoomLevel,
                            },
                        ],
                    } as any)
                }

                function onScanSuccess(decodedText: any) {
                    html5QrCode.stop()
                    UI_dialogClose()
                    camContainer.removeEventListener('touchstart', onTouchStart)
                    return resolve(decodedText)
                }
            }
        } catch {
            UI_dialogOk(I18N_localize('barcode.notSupported'), I18N_localize('barcode.noCameraScan'))
            return reject()
        }
    })
}
